/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useRef, useEffect, useId } from 'react';
import {
  Container,
  Progress,
  Card,
  CardBody,
  Row,
  Col,
  Collapse,
} from 'reactstrap';
import { FaCheck, FaChevronDown, FaLock, FaLockOpen, FaInfoCircle } from 'react-icons/fa';
import MainFooter from "components/Footers/MainFooter.js";
import { useUserAuth } from "../../context/UserContext";
import { useLesson } from "../../hooks/lessonFramework";
import { getFreshIdToken } from "../../utils/authToken";
import { requestLessonsData } from "../../services/userService"
import DemoNavbar from "../../components/Navbars/DemoNavbar.js";
import './TableOfContent.css';
import { useTranslation, Trans } from "react-i18next";
import { TocLesson, LessonStatus, LockedNote, useLockedNote } from "../../components/CourseToc/CourseToc";



const JavaScriptTableComponent = () => {

  const [error, setError] = useState("");
  const mainRef = useRef(null);
  const { setUser, user, logIn } = useUserAuth();
  const { t, i18n } = useTranslation();

  // const [module1, setModule1] = useState([
  //   { title: 'What Is JavaScript?', lessonID: `JS101`, duration: '20 min', completed: false, locked: false, onClick: '/JS_M1_L1' },
  //   { title: 'Where Does JavaScript Run?', lessonID: `JS102`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L2' },
  //   { title: 'How to Write and Run JavaScript', lessonID: `JS103`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L3' },
  //   { title: 'Comments in JavaScript', lessonID: `JS104`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L4' },
  //   { title: 'Basic Syntax of JavaScript', lessonID: `JS105`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L5' },
  //   { title: 'Indentation', lessonID: `JS106`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L5_1' },
  //   { title: 'Naming Conventions', lessonID: `JS107`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L5_2' },
  //   { title: 'Semicolons', lessonID: `JS108`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L5_3' },
  //   { title: 'Quiz 1', lessonID: `JSQ1`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_Q1' }
  // ])

  const [module1, setModule1] = useState([
    { title: 'javascript.module1.lesson1T', lessonID: `JS101`, duration: '20 min', completed: false, locked: false, onClick: '/JS_M1_L1' },
    { title: 'javascript.module1.lesson2T', lessonID: `JS102`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L2' },
    { title: 'javascript.module1.lesson3T', lessonID: `JS103`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L3' },
    { title: 'javascript.module1.lesson4T', lessonID: `JS104`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L4' },
    { title: 'javascript.module1.lesson5T', lessonID: `JS105`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L5' },
    { title: 'javascript.module1.lesson6T', lessonID: `JS106`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L5_1' },
    { title: 'javascript.module1.lesson7T', lessonID: `JS107`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L5_2' },
    { title: 'javascript.module1.lesson8T', lessonID: `JS108`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L5_3' },
    { title: 'javascript.module1.quiz1T', lessonID: `JSQ1`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_Q1' }
  ])

  // const [module2, setModule2] = useState([
  //   { title: 'Declaring Variables with var, let, and const', lessonID: `JS109`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L1' },
  //   { title: 'Differences Between var, let, and const', lessonID: `JS110`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L2' },
  //   { title: 'Scope and Hoisting Basics', lessonID: `JS111`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L3' },
  //   { title: 'Naming Conventions and Best Practices', lessonID: `JS112`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L4' },
  //   { title: 'Reassigning Values', lessonID: `JS113`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_5' },
  //   { title: 'JavaScript Data Types', lessonID: `JS114`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L6' },
  //   { title: 'Number, String, Boolean, Null, Undefined', lessonID: `JS115`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L6_1' },
  //   { title: 'The typeof Operator', lessonID: `JS116`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L6_2' },
  //   { title: 'Arithmetic Operators', lessonID: `JS117`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L7' },
  //   { title: 'Assignment Operators', lessonID: `JS118`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L8' },
  //   { title: 'Strings and String Methods', lessonID: `JS119`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L9' },
  //   { title: 'Quiz 2', lessonID: `JSQ2`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_Q1' }
  // ]);

  const [module2, setModule2] = useState([
    { title: 'javascript.module2.lesson1T', lessonID: `JS109`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L1' },
    { title: 'javascript.module2.lesson2T', lessonID: `JS110`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L2' },
    { title: 'javascript.module2.lesson3T', lessonID: `JS111`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L3' },
    { title: 'javascript.module2.lesson4T', lessonID: `JS112`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L4' },
    { title: 'javascript.module2.lesson5T', lessonID: `JS113`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_5' },
    { title: 'javascript.module2.lesson6T', lessonID: `JS114`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L6' },
    { title: 'javascript.module2.lesson7T', lessonID: `JS115`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L6_1' },
    { title: 'javascript.module2.lesson8T', lessonID: `JS116`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L6_2' },
    { title: 'javascript.module2.lesson9T', lessonID: `JS117`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L7' },
    { title: 'javascript.module2.lesson10T', lessonID: `JS118`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L8' },
    { title: 'javascript.module2.lesson11T', lessonID: `JS119`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_L9' },
    { title: 'Quiz 2', lessonID: `JSQ2`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M2_Q1' }
  ]);


  // const [module3, setModule3] = useState([
  //   { title: 'if, else if, and else', lessonID: `JS120`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
  //   { title: 'Comparison Operators', lessonID: `JS121`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
  //   { title: 'Logical Operators', lessonID: `JS122`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
  //   { title: 'Truthy and Falsy Values', lessonID: `JS123`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
  //   { title: 'The switch Statement', lessonID: `JS124`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
  //   { title: 'Quiz 3', lessonID: `JSQ3`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M3_Q1' }
  // ]);

  const [module3, setModule3] = useState([
    { title: 'javascript.module3.lesson1T', lessonID: `JS120`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
    { title: 'javascript.module3.lesson2T', lessonID: `JS121`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
    { title: 'javascript.module3.lesson3T', lessonID: `JS122`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
    { title: 'javascript.module3.lesson4T', lessonID: `JS123`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
    { title: 'javascript.module3.lesson5T', lessonID: `JS124`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
    { title: 'Quiz 3', lessonID: `JSQ3`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M3_Q1' }
  ]);

  // const [module4, setModule4] = useState([
  //   { title: 'while Loops', lessonID: `JS125`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
  //   { title: 'for Loops', lessonID: `JS126`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
  //   { title: 'Looping Through Strings', lessonID: `JS127`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
  //   { title: 'Looping Through Arrays', lessonID: `JS128`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
  //   { title: 'break and continue', lessonID: `JS129`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
  //   { title: 'Nested Loops', lessonID: `JS130`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
  //   { title: 'Quiz 4', lessonID: `JSQ4`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M4_Q1' }
  // ]);

  const [module4, setModule4] = useState([
    { title: 'javascript.module4.lesson1T', lessonID: `JS125`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
    { title: 'javascript.module4.lesson2T', lessonID: `JS126`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
    { title: 'javascript.module4.lesson3T', lessonID: `JS127`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
    { title: 'javascript.module4.lesson4T', lessonID: `JS128`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
    { title: 'javascript.module4.lesson5T', lessonID: `JS129`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
    { title: 'javascript.module4.lesson6T', lessonID: `JS130`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M1_L1' },
    { title: 'Quiz 4', lessonID: `JSQ4`, duration: '20 min', completed: false, locked: true, onClick: '/JS_M4_Q1' }
  ]);


  const [module5, setModule5] = useState([
    { title: 'Introduction to JavaScript Objects', duration: '20 min', completed: false, locked: true },
    { title: 'Creating and Accessing Object Properties', duration: '20 min', completed: false, locked: true },
    { title: 'Modifying and Deleting Properties', duration: '20 min', completed: false, locked: true },
    { title: 'Nested Objects', duration: '20 min', completed: false, locked: true },
    { title: 'Looping Through Objects with for...in', duration: '20 min', completed: false, locked: true },
    { title: 'Adding Methods to Objects', duration: '20 min', completed: false, locked: true }
  ]);

  const [module6, setModule6] = useState([
    { title: 'Creating and Accessing Arrays', duration: '20 min', completed: false, locked: true },
    { title: 'push, pop, shift, and unshift', duration: '20 min', completed: false, locked: true },
    { title: 'Iterating Over Arrays', duration: '20 min', completed: false, locked: true },
    { title: 'Nested Arrays', duration: '20 min', completed: false, locked: true },
    { title: 'Combining Arrays and Objects', duration: '20 min', completed: false, locked: true }
  ]);

  const [module7, setModule7] = useState([
    { title: 'Defining and Calling Functions', duration: '20 min', completed: false, locked: true },
    { title: 'Parameters and Return Values', duration: '20 min', completed: false, locked: true },
    { title: 'Function Expressions and Arrow Functions', duration: '20 min', completed: false, locked: true },
    { title: 'Scope: Local vs Global', duration: '20 min', completed: false, locked: true },
    { title: 'Callback Functions', duration: '20 min', completed: false, locked: true }
  ]);

  const [module8, setModule8] = useState([
    { title: 'What Is the DOM?', duration: '20 min', completed: false, locked: true },
    { title: 'Selecting Elements', duration: '20 min', completed: false, locked: true },
    { title: 'Changing Text and HTML Content', duration: '20 min', completed: false, locked: true },
    { title: 'Changing Styles with JavaScript', duration: '20 min', completed: false, locked: true },
    { title: 'Responding to User Events', duration: '20 min', completed: false, locked: true }
  ]);

  const [module9, setModule9] = useState([
    { title: 'let, const, and Block Scope', duration: '20 min', completed: false, locked: true },
    { title: 'Template Literals', duration: '20 min', completed: false, locked: true },
    { title: 'Destructuring', duration: '20 min', completed: false, locked: true },
    { title: 'Spread and Rest Operators', duration: '20 min', completed: false, locked: true },
    { title: 'Default Parameters and Arrow Functions', duration: '20 min', completed: false, locked: true }
  ]);

  const [module10, setModule10] = useState([
    { title: 'Review of Key Concepts', duration: '20 min', completed: false, locked: true },
    { title: 'Mini Challenges and Practice Problems', duration: '20 min', completed: false, locked: true },
    { title: 'What’s Next After This Course', duration: '20 min', completed: false, locked: true }
  ]);


  const [lessonArray, setLessonArray] = useState([module1, module2, module3, module4]);
  const completedCount = [...module1, ...module2, ...module3, ...module4].filter((l) => l.completed).length;
  const totalCount = module1.length + module2.length + module3.length;
  const progress = Math.round((completedCount / totalCount) * 100);


  // Keyed on the user id so the fetch re-runs when auth resolves: on a client-side
  // navigation the component can paint before `user` is populated, and the old
  // one-shot effect fetched with an undefined token and never retried — which is
  // why progress showed as 0% until the page was reloaded.
  useEffect(() => {
    updateTableContent()
  }, [user?.uid]);


  const updateTableContent = async (event) => {

    if (!user) return;

    // Mint a fresh token rather than reusing the (possibly hours-old) snapshot on
    // `user`: an expired token fails verification server-side and requestLessonsData
    // swallows the error into [], which reads as "nothing completed".
    const token = await getFreshIdToken(user.accessToken);
    if (!token) return;

    const result = await requestLessonsData(token, "JS01")

    // module1.map(item => ({ ...item })) creates a shallow copy of each object (so you're not mutating state directly).
    const updatedModule1 = module1.map(item => ({ ...item }));
    const updatedModule2 = module2.map(item => ({ ...item }));
    const updatedModule3 = module3.map(item => ({ ...item }));
    const updatedModule4 = module4.map(item => ({ ...item }));

    result.forEach(obj1 => {
      updatedModule1.forEach(obj2 => {
        if (obj1.lessonID === obj2.lessonID && obj1.lessonCompleted === true) {
          obj2.completed = true
        }
      });
    });

    result.forEach(obj1 => {
      updatedModule2.forEach(obj2 => {
        if (obj1.lessonID === obj2.lessonID && obj1.lessonCompleted === true) {
          obj2.completed = true
        }
      });
    });

    result.forEach(obj1 => {
      updatedModule3.forEach(obj2 => {
        if (obj1.lessonID === obj2.lessonID && obj1.lessonCompleted === true) {
          obj2.completed = true
        }
      });
    });

    result.forEach(obj1 => {
      updatedModule4.forEach(obj2 => {
        if (obj1.lessonID === obj2.lessonID && obj1.lessonCompleted === true) {
          obj2.completed = true
        }
      });
    });




    // 2) Enforce within-module sequential unlocks
    let mm1 = applySequentialUnlocksWithinModule(updatedModule1);
    let mm2 = applySequentialUnlocksWithinModule(updatedModule2);
    let mm3 = applySequentialUnlocksWithinModule(updatedModule3);
    let mm4 = applySequentialUnlocksWithinModule(updatedModule4);

    // 3) Enforce cross-module gating
    const cross = applyCrossModuleUnlocks([mm1, mm2, mm3, mm4]);

    // 4) Push back to state
    setModule1(cross[0]);
    setModule2(cross[1]);
    setModule3(cross[2]);
    setModule4(cross[3]);


    // setModule1(updatedModule1);
    // setModule2(updatedModule2);
    // setModule3(updatedModule3);
    // setModule4(updatedModule4);


  }



  // Given a lessons array (with .completed already correct), unlock only the first incomplete lesson
  function applySequentialUnlocksWithinModule(lessons) {
    let firstIncompleteUnlocked = false;
    return lessons.map((l) => {
      // CODE BELLOW IS FOR DEBBUGING. IT UNLOCKS ALL LESSONS
      // if (true) {

      //   return { ...l, locked: false };
      // }

      if (l.completed) {
        // Completed lessons are always unlocked
        return { ...l, locked: false };
      }

      if (!firstIncompleteUnlocked) {
        // First incomplete gets unlocked
        firstIncompleteUnlocked = true;
        return { ...l, locked: false };
      }
      // All other incomplete lessons stay locked
      return { ...l, locked: true };
    });
  }

  // If previous module is fully complete, unlock the first lesson of the next module
  function applyCrossModuleUnlocks(modules) {
    const updated = modules.map(m => [...m]); // shallow copy arrays

    for (let i = 1; i < updated.length; i++) {
      const prevModule = updated[i - 1];
      const prevDone = prevModule.every(l => l.completed);

      if (!prevDone) {
        // lock everything in this module
        updated[i] = updated[i].map(l => ({ ...l, locked: true }));
      } else {
        // ensure at least the first lesson is unlocked (others handled by within-module logic)
        updated[i] = updated[i].map((l, idx) => idx === 0 ? ({ ...l, locked: false }) : l);
      }
    }
    return updated;
  }

  return (
    <>

      <DemoNavbar />
      <main ref={mainRef}>
        <section className="section section-lg bg-primary-gray">
          <Container className="py-5">
            <div className="mb-4">
              <Row className="align-items-center justify-content-between mb-2">
                <Col><h1 className="h2 fw-bold text-dark">{t("table.javascriptTableT")}</h1></Col>
                <Col className="text-end">
                  <small className="text-muted" id="toc-progress-label">{t("table.yourProgress")}</small> <span className="fw-medium">{progress}%</span>
                </Col>
              </Row>
              <Progress
                value={progress}
                color="primary"
                style={{ height: '10px' }}
                barAriaLabelledBy="toc-progress-label"
                barAriaValueText={t("table.progressSummary", { done: completedCount, total: totalCount })}
              />
            </div>

            <Card className="mb-4">
              <CardBody>
                <Row className="align-items-center justify-content-between">
                  <Col md="6">
                    <h2 className="h5 fw-semibold mb-1">{t("table.tableOfContents")}</h2>
                    <p className="text-muted mb-0">{t("table.completeLessonToUnlock")}</p>
                  </Col>
                  <Col md="6" className="d-flex justify-content-end gap-4">
                    <div className="text-center">
                      <small className="text-muted d-block">{t("table.totalLessons")}</small>
                      <span className="fw-medium">{totalCount}</span>
                    </div>
                    {/* BELLOW DISPLAYS DURATION OF ALL LESSONS TOGETHER */}
                    {/* <div className="text-center">
                      <small className="text-muted d-block">Total Duration</small>
                      <span className="fw-medium">8h 45m</span>
                    </div> */}
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <Module
              title="table.module1"
              number={1}
              color={{ bg: '#DBEAFE', text: '#2563EB' }}
              lessons={module1}
            />
            <Module
              title="table.module2"
              number={2}
              color={{ bg: '#EDE9FE', text: '#7C3AED' }}
              lessons={module2}
            />
            <Module
              title="table.module3"
              number={3}
              color={{ bg: '#DCFCE7', text: '#16A34A' }}
              lessons={module3}
            />
            <Module
              title="table.module4"
              number={4}
              color={{ bg: '#DBEAFE', text: '#16A34A' }}
              lessons={module4}
            />

            <Card className="mt-4 border-primary bg-light">
              <CardBody className="d-flex">
                {/* <FaInfoCircle className="text-primary mt-1 me-2" /> */}
                <div>
                  <h2 className="h6 fw-semibold text-primary">{t("table.keepGoing")}</h2>
                  <p className="text-primary small mb-0">
                    {t("table.youCompleted")} {completedCount} {t("table.of")} {totalCount} {t("table.lessons")} ({progress}%){t("table.completedAll")}
                  </p>
                </div>
              </CardBody>
            </Card>
          </Container>
        </section>
      </main>
    </>
  );
};




const Module = ({ title, number, color, lessons }) => {
  const [open, setOpen] = useState(number === 1);
  const [lockedNote, showLockedNote] = useLockedNote();
  const listId = useId();
  const { t, i18n } = useTranslation();

  return (
    <Card className="mb-3 shadow-sm custom-card">
      <h3 className="toc-module-heading">
        <button
          type="button"
          className="toc-module-toggle d-flex justify-content-between align-items-center p-3 "
          aria-expanded={open}
          aria-controls={listId}
          onClick={() => setOpen(!open)}
        >
          <span className="d-flex align-items-center">
            <span
              className="rounded-circle d-flex justify-content-center align-items-center me-3"
              style={{
                width: '32px',
                height: '32px',
                backgroundColor: color.bg,
                color: color.text,
                fontWeight: 'bold',
              }}
            >
              {number}
            </span>
            <span className="h5 mb-0 text-dark fw-semibold">{t(title)}</span>
          </span>
        </button>
      </h3>
      <Collapse isOpen={open} id={listId}>
        <div className="border-top ">
          {lessons.map((lesson, idx) => (


            <TocLesson
              key={`${lesson.lessonID ?? lesson.title}-${idx}`}
              to={lesson.onClick}
              locked={lesson.locked}
              onLocked={showLockedNote}
              className={`lesson-item p-3 m-3 d-flex justify-content-between align-items-center ${lesson.completed ? 'left-border-green' : 'left-border-gray'} ${lesson.locked ? 'opacity-75' : ''}`}
              style={{ cursor: lesson.locked ? 'not-allowed' : 'pointer' }}
            >
              <span className="d-flex  align-items-center ">
                <span className="position-relative me-2">
                  <span className={`  d-flex align-items-center justify-content-center ${lesson.completed ? '' : ''}`}>
                    {/* {completed && <FaCheck className="text-primary" style={{ fontSize: '10px' }} />} */}
                  </span>
                </span>
                {/* <span className="fw-medium text-dark">{lesson.title}</span> */}
                <span className="fw-medium text-dark">{t(lesson.title)}</span>
              </span>
              <span className="d-flex align-items-center gap-2">
                {/* CODE BELLOW DISPLAYS DURATION IN CASE IT NEEDS TO BE DISPLAYED IN THE FURUTE */}
                {/* <span className="text-muted small">{lesson.duration}</span> */}
                {lesson.locked ? (
                  <FaLock className="text-muted" aria-hidden="true" />
                ) : (
                  <FaLockOpen className="text-success" aria-hidden="true" />
                )}
                <LessonStatus completed={lesson.completed} locked={lesson.locked} />
              </span>
            </TocLesson>
          ))}
          <LockedNote count={lockedNote} />
        </div>
      </Collapse>
    </Card>
  );
};

export default JavaScriptTableComponent;
